import { SuiveurModel } from '../../../../types/CreationProcedureModel'
import { INITIAL_VALEURS_FORMULAIRE } from '../../popinAjoutSignataire/types/ajoutSignataireModel'
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form'
import { useContext } from 'react'
import { CreationProcedureContext } from '../../../../CreationProcedure'
import { champsSignataireEnum, champsSuiveurEnum } from '../../popinAjoutSignataire/enums/champsSignataireEnum'
import { Grid } from '@mui/material'
import { fontFamilyMonserrat, gecinaBlueMain, gecinaBrownMain } from '../../../../../../theme'
import Button from '../../../../../../components/button/Button'
import { buttonTypesEnum } from '../../../../../../components/button/enums/buttonTypesEnum'
import TextField from '../../../../../../components/fields/FormTextField'

const FormSuiveurExterne = () => {
	const methods = useForm<SuiveurModel>({
		defaultValues: INITIAL_VALEURS_FORMULAIRE
	})
	const { register, handleSubmit, reset, formState: { errors } } = methods
	const { setFormValues, formValues } = useContext(CreationProcedureContext)

	const onSubmit: SubmitHandler<SuiveurModel> = (values: SuiveurModel) => {
		setFormValues({
			...formValues,
			subscribers: [
				...formValues.subscribers,
				{ [champsSuiveurEnum.courriel]: values[champsSuiveurEnum.courriel] }
			]
		})
		reset(INITIAL_VALEURS_FORMULAIRE)
	}

	return (
		<FormProvider {...methods}>
			<form
				onSubmit={handleSubmit(onSubmit)}
			>
				<Grid container spacing={2} sx={{ mb: '20px' }}>
					<Grid item xs>
						<TextField
							sx={{
								height: 51,
								width: 345,
								border: `1px solid ${gecinaBlueMain} !important`,
								fontFamily: `${fontFamilyMonserrat} !important`,
								fontWeight: 500,
								fontSize: 13
							}}
							register={register(champsSignataireEnum.courriel, {
								required: 'Champ requis',
								pattern: {
									value: /^(.+)@(.+)$/,
									message: 'Le courriel ne respecte pas le format'
								}
							})}
							errors={errors}
							id={champsSignataireEnum.courriel}
							label="Courriel*"
							placeholder="Saisir le courriel du suiveur"
						/>
					</Grid>
				</Grid>
				<Grid container item xs justifyContent="flex-end" sx={{ mt: '10px', ml: 0 }} spacing={2}>
					<Grid item sx={{ maxWidth: 'max-content', ml: '24px', minWidth: 'fit-content' }}>
						<Button
							sx={{
								height: '51px',
								p: 0,
								width: '195px',
								fontWeight: 600,
								lineHeight: '18.29px'
							}}
							bgcolor={gecinaBlueMain}
							color={gecinaBrownMain}
							border={false}
							disabled={false}
							type={buttonTypesEnum.submit}
						>
							Ajouter
						</Button>
					</Grid>
				</Grid>
			</form>
		</FormProvider>
	)
}

export default FormSuiveurExterne